<div class="flex min-h-full min-w-full">
  <mat-divider class="grow" [vertical]="vertical" />
</div>
